/* eslint-disable @typescript-eslint/no-explicit-any */

import { parseJSON, isValid } from 'date-fns';

export const dateReviver = (_key: string, value: any): any => {
  if (typeof value === 'string') {
    const parsed = parseJSON(value);
    return isValid(parsed) ? parsed : value;
  }
  return value;
};

export const parseJsonWithDates = (jsonString: string): any => {
  return JSON.parse(jsonString, dateReviver);
};

export const parseNestedJson = (obj: any): any => {
  if (typeof obj === 'string') {
    try {
      const nestedParsed = JSON.parse(obj);
      return parseNestedJson(nestedParsed);
    } catch {
      return obj;
    }
  } else if (Array.isArray(obj)) {
    return obj.map(parseNestedJson);
  } else if (obj !== null && typeof obj === 'object') {
    const result: any = {};
    for (const key in obj) {
      result[key] = parseNestedJson(obj[key]);
    }
    return result;
  }
  return obj;
};

export const formatJsonWithNestedParsing = (jsonString: string | null): string => {
  if (!jsonString) return '{}';
  try {
    const parsed = JSON.parse(jsonString);
    const fullyParsed = parseNestedJson(parsed);
    return JSON.stringify(fullyParsed, null, 2);
  } catch {
    return jsonString;
  }
};
